import { Switch, Route, useLocation } from "react-router-dom";
import Home from "../views/home/home";
import Verify from "../views/verify/verify";
import Signin from "../views/signin/signin";
import Verticals from "../views/verticals/verticals";

const MainRoute = () => {
    let location = useLocation();

    return (
        <Switch location={location}>
            {/* homepage */}
            <Route path="/" exact component={Verify} />
            <Route path="/verticals" exact component={Verticals} />
            <Route path="/home" component={Home} />
            <Route path="/signin" component={Signin} />
            {/* <Route path="/signup" component={Signup} /> */}
            {/* <Route path="/profile" component={Profile} /> */}
        </Switch>
    );
};

export default MainRoute;
